import { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import Spinner from "../../spinner/Spinner";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";

import formatDate from "../../../components/utils/DateFormatter";
const BranchProductDetails = () => {
    const [productDetails, setProductDetails] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const { data } = location.state || {};

    useEffect(() => {
        if (data) {
            // Ensure quantity_pricing is always an array
            setProductDetails({
                ...data,
                quantity_pricing: Array.isArray(data.quantity_pricing)
                    ? data.quantity_pricing
                    : []
            });
        }
    }, [data]);

    return (
        <MainLayouts>
            <div className="relative sm:rounded-lg py-6 w-full">
                {/* Breadcrumb Navigation */}
                <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                    <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                        <ol className="list-none p-0 inline-flex mb-2">
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Operations
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Branch
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Stock
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-orange1">Details</p>
                            </li>
                        </ol>
                    </nav>
                </section>
                {loading ? (
                    <Spinner loading={loading} />
                ) : productDetails ? (
                    <section className="text-gray-600 body-font">
                        <div className="container px-2">
                            {/* Back Button */}
                            <div className="flex justify-end mb-3">
                                <button
                                    onClick={() => navigate(-1)}
                                    className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                >
                                    <span className="flex justify-center sm:justify-start mx-2">
                                        <ArrowLeftSquare className="mr-2" />
                                        Back
                                    </span>
                                </button>
                            </div>

                            {/* Main Product Card */}
                            <div className="bg-white rounded-lg shadow p-6 mb-6">
                                {/* Product Header */}
                                <div className="flex flex-wrap justify-between items-center mb-6 bg-darkGreen3x px-2 py-2">
                                    <div>
                                        <h5 className="font-bold text-black2 text-xl">
                                            {productDetails.product_units_name.replace(/_/g, ' ').toUpperCase()}
                                        </h5>
                                        <p className="text-black2">
                                            Code: {productDetails.product_code}
                                        </p>
                                    </div>
                                    <div className="mt-4 sm:mt-0">
                                        <span className={`px-4 py-2 rounded-full text-sm font-semibold ${productDetails.is_enabled
                                            ? 'bg-dash text-lGrey'
                                            : 'bg-dash3 text-lGrey'
                                            }`}>
                                            {productDetails.is_enabled ? 'ACTIVE' : 'INACTIVE'}
                                        </span>
                                    </div>
                                </div>

                                {/* Two-column Information Grid */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                                    {/* Basic Information */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <h2 className="text-lg font-semibold mb-4 text-gray-700">Basic Information</h2>
                                        <div className="space-y-3">
                                            <p>
                                                <span className="font-medium text-gray-600">Category:</span> {productDetails.product_categories_name.replace(/_/g, ' ')}
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-600">Description:</span> {productDetails.product_categories_description || 'Not Available'}
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-600">Unit:</span> {productDetails.unit}
                                            </p>

                                        </div>
                                    </div>

                                    {/* Pricing Information */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <h2 className="text-lg font-semibold mb-4 text-gray-700">Pricing</h2>
                                        <div className="space-y-3">
                                            <p>
                                                <span className="font-medium text-gray-600">Base Price:</span> {CurrencyFormatter(productDetails.base_price)}
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-600">Created:</span> {formatDate(productDetails.created_at)}
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-600">Updated:</span> {formatDate(productDetails.updated_at)}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Quantity Pricing Table */}
                                <div className="mb-8">
                                    <h2 className="text-lg font-semibold mb-4 text-gray-700">Quantity Pricing</h2>
                                    <div className="overflow-x-auto">
                                        {productDetails.quantity_pricing.length > 0 ? (
                                            <table className="min-w-full bg-white border border-lGrey">
                                                <thead className="bg-darkGreen3">
                                                    <tr>
                                                        <th className="py-3 px-4 text-left text-lGrey">Min Qty</th>
                                                        <th className="py-3 px-4 text-left text-lGrey">Max Qty</th>
                                                        <th className="py-3 px-4 text-left text-lGrey">Price</th>
                                                        <th className="py-3 px-4 text-left text-lGrey">Description</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {productDetails.quantity_pricing.map((pricing, index) => (
                                                        <tr
                                                            key={index}
                                                            className={index % 2 === 0 ? 'bg-lGrey' : 'bg-white'}
                                                        >
                                                            <td className="py-3 px-4 border-b border-lGrey">{pricing.min_quantity}</td>
                                                            <td className="py-3 px-4 border-b border-lGrey">{pricing.max_quantity || 'No limit'}</td>
                                                            <td className="py-3 px-4 border-b border-lGrey">{CurrencyFormatter(pricing.price)}</td>
                                                            <td className="py-3 px-4 border-b border-lGrey">{pricing.description || "NOT AVAILABLE"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="bg-gray-50 p-4 rounded text-center text-gray-500">
                                                No quantity pricing available for this product
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Additional Notes */}
                                {productDetails.description && (
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <h2 className="text-lg font-semibold mb-2 text-gray-700">Additional Notes</h2>
                                        <p className="text-gray-600">{productDetails.description}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                ) : (
                    <div className="text-center py-10">
                        <p className="text-gray-600">No product details found</p>
                        <button
                            onClick={() => navigate(-1)}
                            className="mt-4 text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5"
                        >
                            Go Back
                        </button>
                    </div>
                )}
            </div>
        </MainLayouts>
    );
};

export default BranchProductDetails;